<template>
  <div class="footer-box">
      <div class="footer-contianer">
        <p class="footer-title">F O L L O W   G R A N D   C H A N N E L   O N   S O C I A L   M E D I A</p>
        <div class="footer-ico">
          <p>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </p>
        </div>
        <div class="footer-msg clearfix">
           <ul>
             <li><span>HEADQUARTER</span></li>
             <li><span>+1 (909) 443 - 5876</span></li>
             <li><span>operator@grandchannel.us</span></li>
             <li><span>13780 Central Ave., Chino, CA 91710 </span></li>
           </ul>
           <ul>
             <li><span>LOCATIONS</span></li>
             <li><i class="width-200">Los Angeles</i><span>New York</span></li>
             <li><span class="width-200">Oakland</span><span>Ask for more...</span></li>
             <li><span class="width-200">Chicago</span></li>
           </ul>
           <ul>
             <li><span>SERVICES</span></li>
             <li><span class="width-200">FBA Forwarding</span><i>Customized Solution</i></li>
             <li><span>E-Fulfillment </span></li>
             <li><span>Distribution</span></li>
           </ul>
        </div>
        <p class="footer-copyright">Copyright © 2018 Grand Channel Inc. All rights reserved.</p>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'footernav',
    data () {
      return {

      }
    },
    methods:{

    },
    computed:{

    },
    mounted(){

    },
    watch:{
      // 如果 `某个属性` 发生改变，这个属性对应的函数就会运行
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .footer-box {
    background: #000000;
    height:420px;
    width: 100%;

    .footer-contianer {
      width:1200px;
      margin:auto;
      height:100%;

      .footer-title {
        font-size: 20px;
        color:#fff;
        height:80px;
        line-height:80px;
        text-align: center;
      }
      .footer-ico {
        p {
          overflow: hidden;
          height:80px;
          width:500px;
          margin:auto;
          span {
            display:block;
            float:left;
            width:20%;
            height:100%;
            &:nth-of-type(1){
                background: url('../../assets/images/Wechat.png') no-repeat center;
            }
            &:nth-of-type(2){
                background: url('../../assets/images/Facebook.png') no-repeat center;
            }
            &:nth-of-type(3){
                background: url('../../assets/images/Linkedin.png') no-repeat center;
            }
            &:nth-of-type(4){
                background: url('../../assets/images/Weibo.png') no-repeat center;
            }
            &:nth-of-type(5){
                background: url('../../assets/images/Twitter.png') no-repeat center;
            }
          }
        }
      }
      .footer-msg {
          ul {
            float:left;
            width:30%;
            text-align:left;
            margin-right: 5%;
            &:nth-of-type(3){
              margin-right:0;
            }
            li {
                display:block;
                height:42px;
                line-height:42px;
                .width-200 {
                  width:160px;
                }
                &:nth-of-type(1){
                  position:relative;
                  span {
                    color:#048EEC;
                    font-size:18px;
                  }
                  :after {
                    content:'';
                    position:absolute;
                    bottom:0;
                    left:0;
                    width:60%;
                    height:2px;
                    background:#fff;
                  }
                }
                span {
                  color:#fff;
                  font-size:14px;
                  display:inline-block;
                }
                i {
                  color:#FF9600;
                  font-size:14px;
                  display:inline-block;
                }
            }
          }
      }
    }
    .footer-copyright {
      text-align:center;
      color:#fff;
      font-size:14px;
      height:80px;
      line-height:80px;
      width:100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/footer/footer.vue